import React, { useState, useEffect } from "react";

const Calorias = ({ rpm = 0 }) => {
  const [calorias, setCalorias] = useState(0);

  useEffect(() => {
    // 🔹 FACTOR: 0.0017 kcal por segundo por cada rpm
    // Ejemplo: 60 rpm → ~6 kcal/min (≈ ciclismo indoor ligero)
    const factor = 0.0017;
    let intervalo;

    if (rpm > 0) {
      intervalo = setInterval(() => {
        const kcalPorSegundo = rpm * factor;
        setCalorias((prev) => {
          const nueva = prev + kcalPorSegundo;
          return parseFloat(nueva.toFixed(5)); // 🔹 evita acumulación de decimales raros
        });
      }, 1000);
    }

    return () => clearInterval(intervalo);
  }, [rpm]);

  return (
    <div
      id="calorias-gastadas"
      data-valor={calorias} // 🔹 valor bruto para guardar
      className="text-xl font-bold mt-2"
    >
      {calorias.toFixed(2)} Kcal
    </div>
  );
};

export default Calorias;
